import { FormEvent } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "lucide-react";
import { api, formatApiError } from "../api/client";

const brandLogo = `${import.meta.env.BASE_URL}brand/aviza-logo.png`;

type InviteInfo = {
  email: string;
  name: string;
  role: string;
  expiresAt: string;
  organization: { name: string };
  hotel?: { name: string } | null;
  location?: { name: string } | null;
};

export function InviteAcceptPage({ token, onAccepted }: { token: string; onAccepted: () => void }) {
  const invite = useQuery({
    queryKey: ["invite", token],
    queryFn: () => api<InviteInfo>(`/api/admin/auth/invitations/${token}`)
  });
  const accept = useMutation({
    mutationFn: (body: unknown) => api("/api/admin/auth/invitations/" + token + "/accept", {
      method: "POST",
      body: JSON.stringify(body)
    }),
    onSuccess: () => {
      window.history.replaceState(null, "", adminHomePath());
      onAccepted();
    }
  });

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    accept.mutate({
      name: String(form.get("name") || invite.data?.name || ""),
      password: String(form.get("password"))
    });
  }

  return (
    <main className="login-shell">
      <section className="login-panel">
        <div className="brand login-brand">
          <img className="brand-logo" src={brandLogo} alt="" aria-hidden="true" />
          <span>Aviza</span>
        </div>
        <h1 className="login-title">Prihvati poziv</h1>
        {invite.isLoading && <p>Provjera pozivnice...</p>}
        {invite.isError && <p className="form-error">Pozivnica nije aktivna ili je istekla.</p>}
        {invite.data && (
          <form className="compact-form" onSubmit={submit}>
            <p>
              {invite.data.organization.name} / {invite.data.hotel?.name ?? "organizacija"} / {invite.data.location?.name ?? "sve lokacije"}
            </p>
            <label>
              Ime
              <input name="name" defaultValue={invite.data.name} required />
            </label>
            <label>
              Email
              <input value={invite.data.email} readOnly />
            </label>
            <label>
              Nova lozinka
              <input name="password" type="password" minLength={12} required autoComplete="new-password" />
            </label>
            <p className="form-note">Rola: {invite.data.role}. Poziv vazi do {new Date(invite.data.expiresAt).toLocaleString()}.</p>
            {accept.error && <p className="form-error">{formatApiError(accept.error)}</p>}
            <button type="submit" disabled={accept.isPending}><ShieldCheck size={16} /> Aktiviraj nalog</button>
          </form>
        )}
      </section>
    </main>
  );
}

function adminHomePath() {
  return window.location.pathname.startsWith("/admin") ? "/admin/" : "/";
}
